/**
 * @example
 * import { MEDIA } from './media';
 * import styled from 'styled-components';
 *
 * const StyledComponent = styled.div`
 *     width: 100%;
 *     @media (${MEDIA.sm}) {
 *         width: 75%;
 *     }
 * `;
 * // Then use `StyledComponent` as a regular React component in the render method
 *
 * @readonly
 * @property {string} sm - Media query for small screens (min-width: 640px).
 * @property {string} md - Media query for medium screens (min-width: 768px).
 * @property {string} lg - Media query for large screens (min-width: 1024px).
 * @property {string} xl - Media query for extra-large screens (min-width: 1280px).
 * @property {string} 2xl - Media query for 2x extra-large screens (min-width: 1536px).
 */
export const MEDIA = {
    "sm": "min-width: 640px",
    "md": "min-width: 768px",
    "lg": "min-width: 1024px",
    "xl": "min-width: 1280px",
    "2xl": "min-width: 1536px"
} as const;

export const componentNames = {
    contentText: "contentText",
    faqs: "faqs",
    features: "features",
    hero: "hero",
    internalLink: "internalLink",
    usp: "usp",
    video: "video",
    text: "text"
} as const;

export const section = {
    card: "card",
    contentPageHero: "content page hero",
    internalLink: "internal linking",
    usp: "usp",
    video: "video"
};

export const linkType = {
    faqOpen: "faq_open",
    modal: "modal",
    page: "page",
    videoPlayModal: "Video play modal"
};

export const clickType = { button: "button", card: "card", playButton: "playbutton", text: "text" };
